import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { useTranslation } from "react-i18next";
import ZipcodeTourPin from "./ZipcodeTourPin";
import MultiTourPin from "./MultiTourPin";
import { isMultiTourMapPoint } from "util/zipcodeVisualization";
import { formatDeparture } from "util/departureDisplay";

function getDepartureText(tour, t) {
  const deps =
    tour?.departures && tour.departures.length > 0
      ? tour.departures
      : tour?.departure
      ? [tour.departure]
      : [];
  if (deps.length === 0) return "";
  return ` (${deps.map((d) => formatDeparture(d, t)).join(", ")})`;
}

function getMapPointTooltipTitle(point, t) {
  if (isMultiTourMapPoint(point)) {
    return (
      <div>
        <div style={{ fontWeight: 700, marginBottom: 4 }}>{point.zipcode}</div>
        {point.tours.map((tour, index) => (
          <div key={tour.id || index} style={{ fontSize: 13, lineHeight: 1.35 }}>
            {tour.tourName}
            {getDepartureText(tour, t)}
          </div>
        ))}
      </div>
    );
  }

  const singleTour = point.tours?.[0] || point;
  const tourName = singleTour?.tourName || point.tourName;
  if (tourName) {
    return (
      <div>
        <div style={{ fontWeight: 700, marginBottom: 4 }}>{point.zipcode}</div>
        <div style={{ fontSize: 13, lineHeight: 1.35 }}>
          {tourName}
          {getDepartureText(singleTour, t)}
        </div>
      </div>
    );
  }

  return point.zipcode;
}

export default function ZipcodeMapMarker({
  point,
  highlighted,
  tooltipClasses,
  onHover,
  onSelect,
}) {
  const { t } = useTranslation("common");
  const multi = isMultiTourMapPoint(point);
  const colors = multi ? point.tours.map((t) => t.color) : [];
  const singleColor =
    point.tours?.[0]?.color || point.tourColor || point.color;

  return (
    <Tooltip
      title={getMapPointTooltipTitle(point, t)}
      placement="top"
      arrow
      classes={tooltipClasses}
      PopperProps={{ disablePortal: false, style: { zIndex: 20 } }}
    >
      <div
        role="button"
        tabIndex={0}
        onMouseEnter={() => onHover(point.id)}
        onMouseLeave={() => onHover(null)}
        onClick={() => onSelect(point)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            onSelect(point);
          }
        }}
        style={{ cursor: "pointer", display: "inline-block", position: "relative", zIndex: highlighted ? 1 : 0 }}
      >
        {multi ? (
          <MultiTourPin colors={colors} size={30} highlighted={highlighted} />
        ) : (
          <ZipcodeTourPin color={singleColor} size={30} highlighted={highlighted} />
        )}
      </div>
    </Tooltip>
  );
}
